import { FunnelSimple, X } from '@phosphor-icons/react';

const Select = ({ testId, value, onChange, options, placeholder }) => (
  <select
    data-testid={testId}
    value={value}
    onChange={(e) => onChange(e.target.value)}
    className="bg-white border-2 border-black rounded-md px-3 py-2 text-black font-bold text-sm min-w-[170px]"
  >
    <option value="">{placeholder}</option>
    {options.map((o) => <option key={o} value={o}>{o}</option>)}
  </select>
);

export const FiltersBar = ({
  date, setDate, dateOptions, showDate = true,
  company, setCompany, companies,
  lineupBy, setLineupBy, lineupBys,
  telecaller, setTelecaller, telecallers,
  onClear, count, total,
}) => {
  const active = company || lineupBy || telecaller;
  return (
    <div className="mb-4 flex flex-wrap items-center gap-3 bg-[#0F3622] border-2 border-[#93C5FD] rounded-md p-3" data-testid="filters-bar">
      <div className="flex items-center gap-2 text-white">
        <FunnelSimple size={20} weight="duotone" className="text-[#93C5FD]" />
        <span className="text-xs font-bold uppercase tracking-wider">Filters</span>
      </div>
      {showDate && (
        <div className="flex items-center gap-2">
          <input
            data-testid="filter-date"
            type="date"
            value={date}
            onChange={(e) => setDate(e.target.value)}
            className="bg-white border-2 border-[#FDE047] rounded-md px-3 py-1.5 text-black font-bold text-sm"
          />
          {dateOptions?.length > 0 && (
            <select
              data-testid="filter-date-quick"
              value={dateOptions.includes(date) ? date : ''}
              onChange={(e) => e.target.value && setDate(e.target.value)}
              className="bg-white border-2 border-[#FDE047] rounded-md px-2 py-1.5 text-black font-bold text-sm"
            >
              <option value="">Jump to a day…</option>
              {dateOptions.map((d) => <option key={d} value={d}>{d}</option>)}
            </select>
          )}
        </div>
      )}
      <Select testId="filter-company" value={company} onChange={setCompany} options={companies} placeholder="All companies" />
      <Select testId="filter-lineup-by" value={lineupBy} onChange={setLineupBy} options={lineupBys} placeholder="All lineup-by" />
      <Select testId="filter-telecaller" value={telecaller} onChange={setTelecaller} options={telecallers} placeholder="All users / telecallers" />
      {active && (
        <button data-testid="filters-clear" onClick={onClear} className="flex items-center gap-1 px-3 py-1.5 bg-[#F87171] text-white border-2 border-black rounded-md text-xs font-bold hover:-translate-y-0.5 transition-all">
          <X size={14} weight="bold" /> Clear
        </button>
      )}
      <div className="ml-auto text-sm font-bold text-white" data-testid="filters-count">
        {count} <span className="text-[#93C5FD]">of</span> {total}
      </div>
    </div>
  );
};
